export enum HelpTextType {
  HELP_URL = 'helpUrl',
  HELP = 'help'
}
